import React, { Component } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { PrivateRoute } from './privateRoute'
import Header from './Header';
// import Footer from './Footer'
import MyCoursePage from './pages/myCourse'
import SignIn from './pages/signIn'
import Register from './pages/Register'
import Course from './pages/course'
import CourseManager from './pages/courseManager'
import UserManager from './pages/userManager'
import EditCourse from './pages/editCourse'
import Settings from './pages/settings'
import AllCoursePage from './pages/AllCoursePage'
import News from './pages/News';

class AppRouter extends Component {
    render() {
        return (
            <React.Fragment>
                <CssBaseline />
                <BrowserRouter>
                    <div className="container-fluid">
                        <Route path="/" component={Header} />
                        <Switch>
                            <PrivateRoute exact path="/" component={News} adminOnly={false} />
                            <PrivateRoute path="/courses" component={AllCoursePage} adminOnly={false} />
                            <PrivateRoute path="/mycourse" component={MyCoursePage} adminOnly={false} />
                            <PrivateRoute path="/course/:id" component={Course} adminOnly={false} />
                            <PrivateRoute path="/courseManager" component={CourseManager} adminOnly={true} />
                            <PrivateRoute path="/newCourse" component={EditCourse} adminOnly={true} />
                            <PrivateRoute path="/editCourse/:id" component={EditCourse} adminOnly={true} />
                            <PrivateRoute path="/userManager" component={UserManager} adminOnly={true} />
                            <PrivateRoute path="/Settings" component={Settings} adminOnly={true} />
                            <PrivateRoute path="/news" component={News} adminOnly={false} />
                            <Route path="/login" component={SignIn} />
                            <Route path="/register" component={Register} />
                        </Switch>
                        {/* <div style={{ height: 151 }}></div> */}
                        {/* <Route path="/" component={Footer} /> */}
                    </div>
                </BrowserRouter>
            </React.Fragment>
        );
    }
}

export default AppRouter;